export default __webpack_public_path__ + "static/media/IMG-20250105-WA0020.9ddb7405.jpg";